import { type ReactNode } from 'react';
import { useEditableTranslation } from '#common/i18n/edit-mode.tsx';
import { type CoreTheme } from '#speaker-shop/hooks/useCoreTheme.ts';
import ContactForm from '#speaker-shop/routes/resources+/contact-form.js';

import { Dialog } from './Dialog';

export function ContactFormDialog({ topic, fixedBodyPart, description, open, onClose, appearance = 'legacy', theme }: {
    topic: string;
    fixedBodyPart?: string;
    description: ReactNode;
    open: boolean;
    onClose: () => void;
    appearance?: 'legacy' | 'unified';
    theme?: CoreTheme;
}) {
    const { t } = useEditableTranslation('contact');
    return (
        <Dialog
            title={t('title')}
            description={description}
            icon='heroicons--envelope'
            open={open}
            onClose={onClose}
            appearance={appearance}
            theme={theme}
            showCloseIcon
        >
            <ContactForm
                topic={topic}
                fixedBodyPart={fixedBodyPart}
                appearance={appearance}
                onSendSuccessful={() => setTimeout(onClose, 1500)}
            />
        </Dialog>
    );
}
